<script type="text/javascript">
import axios from 'axios'
// App.vue中的ref引用
var refs

// 根据Key从cookie中获取相应值
function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  var arr = document.cookie.match(reg)
  if (arr) {
    return name == 'Authorization' ? decodeURIComponent(arr[2]) : arr[2]
  } else {
    return null
  }
}

// 设置rem
function setPhoneRem() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  var remSize
  // 判断是否锤子坚果Pro2手机并在在微信浏览器
  if (
    ua.indexOf('os105') > -1 &&
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    window.screen.width == 432
  ) {
    remSize = (window.screen.width / 37.5 / 3) * 4 + 'px'
  } else {
    remSize = window.screen.width / 37.5 + 'px'
  }
  return remSize
}

// 获取首页url
function getIndexPage() {
  if (location.host.indexOf('test') != -1) {
    return 'http://m.test.jiehun.com.cn'
  } else if (location.host.indexOf('beta') != -1) {
    return 'http://m-beta.jiehun.com.cn'
  } else {
    return 'https://m.jiehun.com.cn'
  }
}
// h5登录
function h5Login(u) {
  if (location.host.indexOf('test') != -1) {
    location.href = '//m.test.jiehun.com.cn/login?u=' + u
  } else if (location.host.indexOf('beta') != -1) {
    location.href = '//m-beta.jiehun.com.cn/login?u=' + u
  } else {
    location.href = '//m.jiehun.com.cn/login?u=' + u
  }
}

// 获取当前地址域名
function getUrlDomain() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/jiri/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/jiri/'
  }
  return urlDomain
}

// 获取当前地址域名
function getUrlDomainForBudget() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/yusuan/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/yusuan/'
  }
  return urlDomain
}

// 获取当前地址域名
function getUrlDomainForTask() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/task/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/task/'
  }
  return urlDomain
}

// 获取公共地址域名
function getBaseUrlDomain() {
  var urlDomain = process.env.VUE_APP_URL + '/'
  return urlDomain
}

// 获取登记处地址域名
function getUrlDomainForRegistry() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/registry/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/registry/'
  }
  return urlDomain
}

// 获取结婚誓词地址域名
function getUrlDomainForVows() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/vows/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/vows/'
  }
  return urlDomain
}

// 获取当前地址域名
function getShareUrlDomain() {
  // var urlDomain = ''
  // // TODO 现网环境删除
  // if (DEV_MODE) {
  //   urlDomain = 'http://192.168.0.156:8080/'
  // } else {
  //   urlDomain = '//fun.jiehun.com.cn/luckyday/'
  // }
  // return urlDomain
  return `${document.domain}/`
}

/* 判断手机是否为IPHONEX */
function setIPhoneX() {
  var ret =
    /iphone/gi.test(navigator.userAgent) &&
    (screen.height == 812 && screen.width == 375)
  this.isIPhoneX = ret
}


/**
 * 粗略判断是否是合法的 APP version
 * @param {String} version APP 版本号 e.g. '6.20.0'
 * @return {Boolean} 返回布尔值
 */
function isValidVersion(version) {
  return /^\d+\.\d+\.\d+$/.test(version);
}

/**
 * 将字符串形式的 APP 版本号，转换成整数形式，便于版本号比较
 * e.g. '6.20.0' -> 60200
 * @param {String} version 字符串形式的版本号
 * @return {Number} 转换成整数形式返回
 */
function getAppVersion(version) {
  const appVersion = version.split('.').map(item => +item);
  return appVersion[0] * 10000 + appVersion[1] * 100 + appVersion[2];
}

/**
 * 将当前的 APP 版本号和指定的 APP 版本号比较，返回一些比较信息
 * @param  {String}   designationVersion 指定的 APP 版本，e.g. '6.20.0'
 * @return {Object}   isApp: 是否是在 APP 中   isGreater: 当前 APP 版本是否大于 designationVersion（指定的 APP 版本）
 */
function compareAppVersion(designationVersion) {
  var that = this
  // 参数校验，如果参数不是合法的 APP 版本号
  if (!that.isValidVersion(designationVersion)) {
    throw new Error('参数不合法，请输入正确的 APP 版本号');
  }
  const currentVersion = that.getCookie('app-version');
  if (!currentVersion) return { isApp: false };
  const currentAppVersion = that.getAppVersion(currentVersion);
  const designationAppVersion = that.getAppVersion(designationVersion);
  return {
    isApp: true,
    isGreater: currentAppVersion >= designationAppVersion,
  };
}


// const DEV_MODE = true // 开发模式
const DEV_MODE = false // 正式发布

var isIPhoneX = false

/**
 * 1899 - 2100 年的农历数据
 *
 * 数据格式: 0x04bd8是5个16进制数,20bit的数,代表公历日期为 1900年01月31日,农历日期为1900年01月01日
 *
 * 说明：农历中大月为30天,小月为29天
 *
 * 前4位(即0): 表示当年润月的大小月,为1则润大月,为0则润小月。
 * 中间12位(即4bd): 每位代表一个月,为1则为大月,为0则为小月。12位表示1到12个月
 * 后4位(即8): 代表这一年的润月月份,为0则不润。首4位要与末4位搭配使用
 */
var lunarInfo = [
  0x0ab50, //1899
  0x04bd8,
  0x04ae0,
  0x0a570,
  0x054d5,
  0x0d260,
  0x0d950,
  0x16554,
  0x056a0,
  0x09ad0,
  0x055d2, //1900-1909
  0x04ae0,
  0x0a5b6,
  0x0a4d0,
  0x0d250,
  0x1d255,
  0x0b540,
  0x0d6a0,
  0x0ada2,
  0x095b0,
  0x14977, //1910-1919
  0x04970,
  0x0a4b0,
  0x0b4b5,
  0x06a50,
  0x06d40,
  0x1ab54,
  0x02b60,
  0x09570,
  0x052f2,
  0x04970, //1920-1929
  0x06566,
  0x0d4a0,
  0x0ea50,
  0x06e95,
  0x05ad0,
  0x02b60,
  0x186e3,
  0x092e0,
  0x1c8d7,
  0x0c950, //1930-1939
  0x0d4a0,
  0x1d8a6,
  0x0b550,
  0x056a0,
  0x1a5b4,
  0x025d0,
  0x092d0,
  0x0d2b2,
  0x0a950,
  0x0b557, //1940-1949
  0x06ca0,
  0x0b550,
  0x15355,
  0x04da0,
  0x0a5b0,
  0x14573,
  0x052b0,
  0x0a9a8,
  0x0e950,
  0x06aa0, //1950-1959
  0x0aea6,
  0x0ab50,
  0x04b60,
  0x0aae4,
  0x0a570,
  0x05260,
  0x0f263,
  0x0d950,
  0x05b57,
  0x056a0, //1960-1969
  0x096d0,
  0x04dd5,
  0x04ad0,
  0x0a4d0,
  0x0d4d4,
  0x0d250,
  0x0d558,
  0x0b540,
  0x0b6a0,
  0x195a6, //1970-1979
  0x095b0,
  0x049b0,
  0x0a974,
  0x0a4b0,
  0x0b27a,
  0x06a50,
  0x06d40,
  0x0af46,
  0x0ab60,
  0x09570, //1980-1989
  0x04af5,
  0x04970,
  0x064b0,
  0x074a3,
  0x0ea50,
  0x06b58,
  0x055c0,
  0x0ab60,
  0x096d5,
  0x092e0, //1990-1999
  0x0c960,
  0x0d954,
  0x0d4a0,
  0x0da50,
  0x07552,
  0x056a0,
  0x0abb7,
  0x025d0,
  0x092d0,
  0x0cab5, //2000-2009
  0x0a950,
  0x0b4a0,
  0x0baa4,
  0x0ad50,
  0x055d9,
  0x04ba0,
  0x0a5b0,
  0x15176,
  0x052b0,
  0x0a930, //2010-2019
  0x07954,
  0x06aa0,
  0x0ad50,
  0x05b52,
  0x04b60,
  0x0a6e6,
  0x0a4e0,
  0x0d260,
  0x0ea65,
  0x0d530, //2020-2029
  0x05aa0,
  0x076a3,
  0x096d0,
  0x04bd7,
  0x04ad0,
  0x0a4d0,
  0x1d0b6,
  0x0d250,
  0x0d520,
  0x0dd45, //2030-2039
  0x0b5a0,
  0x056d0,
  0x055b2,
  0x049b0,
  0x0a577,
  0x0a4b0,
  0x0aa50,
  0x1b255,
  0x06d20,
  0x0ada0, //2040-2049
  0x14b63,
  0x09370,
  0x049f8,
  0x04970,
  0x064b0,
  0x168a6,
  0x0ea50,
  0x06b20,
  0x1a6c4,
  0x0aae0, //2050-2059
  0x0a2e0,
  0x0d2e3,
  0x0c960,
  0x0d557,
  0x0d4a0,
  0x0da50,
  0x05d55,
  0x056a0,
  0x0a6d0,
  0x055d4, //2060-2069
  0x052d0,
  0x0a9b8,
  0x0a950,
  0x0b4a0,
  0x0b6a6,
  0x0ad50,
  0x055a0,
  0x0aba4,
  0x0a5b0,
  0x052b0, //2070-2079
  0x0b273,
  0x06930,
  0x07337,
  0x06aa0,
  0x0ad50,
  0x14b55,
  0x04b60,
  0x0a570,
  0x054e4,
  0x0d160, //2080-2089
  0x0e968,
  0x0d520,
  0x0daa0,
  0x16aa6,
  0x056d0,
  0x04ae0,
  0x0a9d4,
  0x0a2d0,
  0x0d150,
  0x0f252, //2090-2099
  0x0d520
] //2100
/**
 * 万年历支持查询的年份范围
 */
var minYear = 1899 //最小年限
var maxYear = 2025 //最大年限

var monthCN = [
  '正月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '腊月'
] // 农历月
// 农历日
var dayCN = [
  '初一',
  '初二',
  '初三',
  '初四',
  '初五',
  '初六',
  '初七',
  '初八',
  '初九',
  '初十',
  '十一',
  '十二',
  '十三',
  '十四',
  '十五',
  '十六',
  '十七',
  '十八',
  '十九',
  '二十',
  '廿一',
  '廿二',
  '廿三',
  '廿四',
  '廿五',
  '廿六',
  '廿七',
  '廿八',
  '廿九',
  '三十',
  '卅一'
]
// 二十四节气数据，节气点时间(单位是分钟)从0小寒起算
var termInfo = [
  0,
  21208,
  42467,
  63836,
  85337,
  107014,
  128867,
  150921,
  173149,
  195551,
  218072,
  240693,
  263343,
  285989,
  308563,
  331033,
  353350,
  375494,
  397447,
  419210,
  440795,
  462224,
  483532,
  504758
]
// 二十四节气
var solarTerm = [
  '小寒',
  '大寒',
  '立春',
  '雨水',
  '惊蛰',
  '春分',
  '清明',
  '谷雨',
  '立夏',
  '小满',
  '芒种',
  '夏至',
  '小暑',
  '大暑',
  '立秋',
  '处暑',
  '白露',
  '秋分',
  '寒露',
  '霜降',
  '立冬',
  '小雪',
  '大雪',
  '冬至'
]

var lunarFestivalDate = [
  '腊月初八',
  '腊月廿三',
  '腊月三十',
  '正月初一',
  '正月十五',
  '二月初二',
  '五月初五',
  '七月初七',
  '七月十五',
  '八月十五',
  '九月初九'
]
var lunarFestivalName = [
  '腊八节',
  '小年',
  '除夕',
  '春节',
  '元宵节',
  '龙抬头',
  '端午节',
  '情人节',
  '中元节',
  '中秋节',
  '重阳节'
]

function getLunarFestival(lunarNow) {
  var that = this
  var festivalName = ''
  for (var i = 0; i < that.lunarFestivalDate.length; i++) {
    if (lunarNow == that.lunarFestivalDate[i]) {
      festivalName = that.lunarFestivalName[i]
      break
    }
  }

  return festivalName
}

/**
 *
 * 根据日期获取某天的农历日期
 *
 *
 * 说明：通过当前日期和1899年1月10日的日期所差的天数,分别计算出当前日期对应的农历的年月日
 *
 * @param {Number} y 年
 * @param {Number} m 月
 * @param {Number} d 日
 */
function getLunarCalendar(y, m, d) {
  var that = this
  var res = {}

  var baseDate = new Date(1899, 1, 10)
  var curDate = new Date(y, m - 1, d)
  var offset = parseInt((curDate - baseDate) / 86400000) // 计算出当前日期到1899年1月10日所差的天数,(农历1899年1月1日)

  // 用offset依次减去每一年的天数,直至不够减,此时i就表示当前农历年份
  for (var l = that.minYear; l <= that.maxYear; l++) {
    var daysIn = that.yearDays(l)
    if (offset - daysIn < 1) {
      break
    } else {
      offset -= daysIn
    }
  }
  // 查找对应的农历年
  res.year = l
  res.lunarYear = l
  // 此时offset为,当前日期到今年农历月份的天数,进而通过这个差值计算出对应的农历月份

  // 当年闰月的月份
  var leap = that.leapMonth(res.year)
  var isLeap = false
  //设定当年是否有闰月
  if (leap > 0) {
    isLeap = true
  }
  var isLeapMonth = false
  for (var i = 1; i <= 12; i++) {
    var days = null

    //如果有闰月则减去闰月对应的天数
    if (isLeap && i == leap + 1 && isLeapMonth == false) {
      isLeapMonth = true
      i--
      days = that.leapDays(res.year)

      // 如果没有闰月则减去正常月天数
    } else {
      isLeapMonth = false
      days = that.monthDays(res.year, i)
    }
    // 如果offset-days小于0了说明,offset找到对应月份
    if (offset - days < 0) break
    offset = offset - days
  }
  i = i == 13 ? 1 : i
  res.month = (leap == i && isLeapMonth ? '闰' : '') + that.monthCN[i - 1]
  res.day = that.dayCN[offset + 1 - 1] // 偏移量加1,得到对应的农历日期数. offset为当月1月1日的偏移量

  res.lunarMonth = i
  res.lunarDay = offset + 1

  return res
}

/**
 * 返回y年农历的总天数
 * @param {Number} y 年
 */
function yearDays(y) {
  var that = this
  var i,
    sum = 0
  for (i = 0x08000; i > 0x00008; i >>= 1) {
    sum += that.lunarInfo[y - 1899] & i ? 30 : 29
  }
  return sum + that.leapDays(y) // y年的天数再加上当年闰月的天数
}

/**
 * 返回y年农历的中闰月,如果y年没有闰月返回0
 * @param {Number} y 年
 */
function leapMonth(y) {
  var that = this
  return that.lunarInfo[y - 1899] & 0x0000f
}

/**
 * 返回y年农历的指定月份的天数
 * @param {Number} y 年
 */
function monthDays(y, m) {
  var that = this
  return that.lunarInfo[y - 1899] & (0x10000 >> m) ? 30 : 29
}

/**
 * 返回y年农历的中闰月的天数
 * @param {Number} y 年
 */
function leapDays(y) {
  var that = this
  if (that.leapMonth(y)) {
    return that.lunarInfo[y - 1899] & 0x10000 ? 30 : 29
  } else {
    return 0
  }
}

/**
 * 某年的第n个节气为几日
 * 地球公转时间:31556925974.7 毫秒
 * 由于农历24节气交节时刻采用近似算法,可能存在少量误差(30分钟内)
 * 1900年的正小寒点：01-06 02:03:57,1900年为基准点
 *
 * @param {Number} y 公历年
 * @param {Number} n 第几个节气，从0小寒起算
 *
 */
function getTerm(y, n) {
  var that = this
  var offDate = new Date(
    31556925974.7 * (y - 1900) +
      that.termInfo[n] * 60000 +
      Date.UTC(1900, 0, 6, 2, 3, 57)
  )
  return offDate.getUTCDate()
}
/**
 * 获取公历年一年的二十四节气
 * 返回节气中文名
 */
function getYearTerm(y, m, d) {
  var that = this
  if ((y == 2019 || y == 2023) && m == 6 && d == 21) {
    return '夏至'
  }
  if ((y == 2019 || y == 2023) && m == 6 && d == 22) {
    return null
  }
  var res = null
  var month = 0
  for (var i = 0; i < 24; i++) {
    var day = that.getTerm(y, i)
    if (i % 2 == 0) month++
    if (month == m && day == d) {
      res = that.solarTerm[i]
    }
  }
  return res
}

function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

// 设置当前Cookie
function setCookie(name, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

//判断是否是微信浏览器的函数
function isWeiXin() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 获取微信js-sdk配置接口URL
function getWxConfigUrl() {
  // 测试环境
  if (location.host.indexOf('test') > -1) {
    return 'http://open.test.jiehun.com.cn/common/wechat/get-init-weixin'
    // beta及正式环境
  } else {
    return 'https://open.jiehun.com.cn/common/wechat/get-init-weixin'
  }
}
/**
 * 预算-获取微信配置
 */
function weixinInitFromBudget(href, wx , budgetId) {
  var that = this
  var params = {
    type: 'hunbasha',
    user_agent: 'MicroMessenger_rer',
    authUrl: href
  }
  // 微信授权
  axios
    .post(that.getWxConfigUrl(), params, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: that.getCookie('Authorization')
      }
    })
    .then(function(response) {
      var data = response.data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.data.appId, // 必填，公众号的唯一标识appId
        timestamp: data.data.timestamp + '', // 必填，生成签名的时间戳
        nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
        signature: data.data.signature, // 必填，签名
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
      })
      wx.ready(function() {
        var link = location.origin + '/budget/share.html?budgetId='+budgetId
        var imgUrl =
          'https://img.hbhcdn.com/dmp/other/1542211200/jh-img-orig-ga_1062897295236931584_100_100_12212.png'
        //分享朋友圈
        wx.onMenuShareTimeline({
          title: '我的结婚预算清单，来帮我看看~',
          link: link,
          imgUrl: imgUrl, // 自定义图标
          trigger: function() {},
          success: function() {},
          cancel: function() {},
          fail: function() {}
        })
        //分享给好友
        wx.onMenuShareAppMessage({
          title: '我的结婚预算清单，来帮我看看~', // 分享标题
          desc: '我的结婚预算清单，来帮我看看~', // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 自定义图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          // 用户确认分享后执行的回调函数
          success: function() {},
          // 用户取消分享后执行的回调函数
          cancel: function() {}
        })
        wx.error(function() {})
      })
    })
    .catch(function() {})
}


export default {
  refs,
  setPhoneRem,
  getCookie,
  h5Login,
  getUrlDomain,
  getUrlDomainForBudget,
  getUrlDomainForTask,
  getUrlDomainForRegistry,
  getUrlDomainForVows,
  getBaseUrlDomain,
  getShareUrlDomain,
  setIPhoneX,
  getLunarCalendar,
  getYearTerm,
  yearDays,
  leapMonth,
  monthDays,
  leapDays,
  getTerm,
  getLunarFestival,
  getIndexPage,
  getUrlParam,
  setCookie,
  isWeiXin,

  isValidVersion,
  getAppVersion,
  compareAppVersion,

  DEV_MODE,
  isIPhoneX,
  lunarInfo,
  minYear,
  maxYear,
  monthCN,
  dayCN,
  termInfo,
  solarTerm,
  lunarFestivalDate,
  lunarFestivalName,

  getWxConfigUrl,
  weixinInitFromBudget
}
</script>
